<template>
	<div>
		<div v-if="name === 'addProductOnTotalRedemptions'">
			<addproductontotalredemptions
				:products="products"
				:rule="rule"
			/>
		</div>
		<div v-if="name === 'displayProductOnTotalRedemptions'">
			<displayproductontotalredemptions
				:products="products"
				:rule="rule"
			/>
		</div>
		<div v-if="name === 'messageOnRedemption'">
			<messageonredemption :key="rule.id" :rule="rule" :products="products" :message-lists="messageLists"/>
		</div>
		<div v-if="name === 'messageOnTotalRedemptions'">
			<messageontotalredemptions :key="rule.id" :rule="rule" :products="products" :message-lists="messageLists"/>
		</div>
		<div v-if="name === 'removeProductOnTotalRedemptions'">
			<removeproductontotalredemptions
				:key="rule.id"
				:rule="rule"
				:products="products"
				:callback="callback"
				:index_position="index_position"
			/>
		</div>
		<div v-if="name === 'unlimitedRedemptions'">
			<unlimitedredemptions
				:key="rule.id"
				:rule="rule"
				:products="products"
				:callback="callback"
				:index_position="index_position"
				:deal="deal"
				@set-end-date="rule.settings.end_dates.push(Bandwango.dateToUtc($event));"
				@remove-end-date="rule.settings.end_dates.splice($event, 1)"
			/>
		</div>
		<div v-if="name === 'limitedRedemptions'">
			<limitedredemptions
				:key="rule.id"
				:rule="rule"
				:products="products"
				:callback="callback"
				:index_position="index_position"
				:deal="deal"
				@set-end-date="rule.settings.end_dates.push(Bandwango.dateToUtc($event));"
				@remove-end-date="rule.settings.end_dates.splice($event, 1)"
			/>
		</div>
        <div v-if="name === 'awardPointsOnRedemption'">
            <award-points-on-redemption
                :key="rule.id"
                :deal="deal"
                :products="products"
                :rule="rule"
                :venues="venues"
            />
        </div>
		<div v-if="name === 'awardPointsOnRedemptionByCategory'">
			<award-points-on-redemption-by-category
				:key="rule.id"
				:categories="categories"
				:deal="deal"
				:products="products"
				:rule="rule"
				:venues="venues"
			/>
		</div>
		<div v-if="name === 'awardPointsOnSignUp'">
			<award-points-on-sign-up
				:key="rule.id"
				:deal="deal"
				:rule="rule"
			/>
		</div>
	</div>
</template>

<script>
import addProductOnTotalRedemptions from './addProductOnTotalRedemptions';
import displayProductOnTotalRedemptions from './displayProductOnTotalRedemptions';
import messageOnRedemption from './messageOnRedemption';
import messageOnTotalRedemptions from './messageOnTotalRedemptions';
import removeProductOnTotalRedemptions from './removeProductOnTotalRedemptions';
import unlimitedRedemptions from './unlimitedRedemptions';
import limitedRedemptions from './limitedRedemptions';
import awardPointsOnRedemption from "./awardPointsOnRedemption";
import awardPointsOnSignUp from "./awardPointsOnSignUp";
import awardPointsOnRedemptionByCategory from "./awardPointsOnRedemptionByCategory";

	export default {
		props: {
			name: {
				type: String,
				required: true
			},
			products: {
				type: Array,
				required: true
			},
			rule: {
				type: Object,
				required: true
			},
			deal: {
				type: Object,
			},
			callback: {
				type: Function
			},
			index_position: {
				type: Number
			},
			messageLists: {
				type: Array,
				default() {
					return []
				}
			},
            venues: Array,
			categories: Array,
		},
		components: {
			'addproductontotalredemptions': addProductOnTotalRedemptions,
			'displayproductontotalredemptions': displayProductOnTotalRedemptions,
			'messageonredemption': messageOnRedemption,
			'messageontotalredemptions': messageOnTotalRedemptions,
			'removeproductontotalredemptions': removeProductOnTotalRedemptions,
			'unlimitedredemptions': unlimitedRedemptions,
			'limitedredemptions': limitedRedemptions,
            'award-points-on-redemption': awardPointsOnRedemption,
			'award-points-on-redemption-by-category': awardPointsOnRedemptionByCategory,
			'award-points-on-sign-up': awardPointsOnSignUp,
		},
		beforeMount() {
			if(!Array.isArray(this.rule.settings.product_ids)) this.$set(this.rule.settings, 'product_ids', []);
			if(!this.rule.settings.end_dates) this.$set(this.rule.settings, 'end_dates', []);
			if(!this.rule.settings.end_dates) this.$set(this.rule.settings, 'prep_date', []);
			if(!Array.isArray(this.rule.settings.product_options)) this.$set(this.rule.settings, 'product_options', []);
			this.rule.settings.redemptions_needed = this.rule.settings.redemptions_needed ? this.rule.settings.redemptions_needed : 1;
			this.rule.settings.max_sends = this.rule.settings.max_sends ? this.rule.settings.max_sends : 1;
			this.rule.settings.display_on_pass = this.rule.settings.display_on_pass ? this.rule.settings.display_on_pass : "visible";
		},
	}
</script>